import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { IconeContainer, InfoContainer, TextContainer } from "./style";
import { FaExclamation } from "react-icons/fa";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: () => void;
}

export function ModalConfirmarCancelarEditarFornecedor({
  show,
  handleClose,
  onSubmit,
}: Props) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Editar fornecedor"
      centered
    >
      <InfoContainer>
        <IconeContainer>
          <FaExclamation />
        </IconeContainer>
        <TextContainer>Deseja sair sem salvar as alterações?</TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "200px" }}
          outline
          variante="primary"
          onClick={handleClose}
        >
          Continuar editando
        </PrimaryButton>
        <PrimaryButton style={{ width: "150px" }} onClick={onSubmit}>
          Sair sem salvar
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
